<template>
    <div class="ipad-buy-now">
        <img class="ipad-buy-now__icon" src="//assets.procreate.art/img/procreate-icon.png" alt="" />
        <h2 class="ipad-buy-now__heading text-heading">{{ $t("ipad.buy.heading") }}</h2>
        <i18n path="ipad.buy.body" tag="p" class="ipad-buy-now__body text-body">
            <template v-if="procreate" v-slot:price>{{ procreate.formattedPrice }} {{ procreate.currency }}</template>
            <template v-slot:app_store>
                <pro-link v-fathom-event:click="['TYVOSEIS']" :href="ctaLink" target="_blank">{{ $t("global.app_store") }}</pro-link>
            </template>
        </i18n>
        <ProButton v-fathom-event:click="['TYVOSEIS']" variant="primary" pill :href="ctaLink" target="_blank" :aria-label="$t('a11y-labels.buy.ipad')">
            {{ $t("global.buy_now") }}
        </ProButton>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: {
        ctaLink: {
            type: String,
            default: "https://apps.apple.com/app/procreate/id425073498",
        },
    },

    computed: {
        ...mapGetters({
            procreate: "appStore/getProcreate",
        }),
    },

    mounted() {
        if (!this.procreate) {
            this.$store.dispatch("appStore/fetchProcreate");
        }
    },
};
</script>
